module.exports = __webpack_public_path__ + "img/world.3b1a1e4.jpg";